import Vue from 'vue'
import moment from 'moment'

Vue.filter('dateFormat', function(value) {
  if (value instanceof Date) {
    return moment(value).format('YYYY/MM/DD')
  } else {
    const microsecond = value * 1000
    const date = new Date(microsecond)
    return moment(date).format('YYYY/MM/DD')
  }
})

Vue.filter('fullDateTimeFormat', function(value) {
  if (value instanceof Date) {
    return moment(value).format('YYYY-MM-DD HH:mm:ss')
  } else {
    const microsecond = value * 1000
    const date = new Date(microsecond)
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }
})

// 錢的格式,目前JPY(main)無條件捨去取至小數點後2位
// 其他幣別: 無條件捨去取至小數點後6位
export function amountFormat(num, decimals = 2) {
  const factor = Math.pow(10, decimals)
  const truncated = Math.floor(num * factor) / factor

  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}
